import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthService } from '../../handling_data/services/AuthService';

export const ProtectedRoute: React.FC = () => {
    if (!AuthService.isAuthenticated()) {
        // Redirect to login if not authenticated
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};
